import React from 'react';
import { CircularProgress, IconButton } from '@mui/material';
import Tooltip, { DefaultTooltipPopperProps } from 'js/components/elements/mui/Tooltip';
import { ReactComponent as RefreshIcon } from 'new/components/icons/refresh.svg';

const minStyle = { width: 32, height: 32 };

const btnStyle = {
  width: 32,
  height: 32,
  border: '1px solid var(--Greyscale-200, #C8C9D0)',
};

type Props = {
  showTooltip?: boolean;
  color?: string;
  isLoading: boolean;
  onRefreshClicked: () => void;
};

export function RefreshRoundedIconButton({
  showTooltip = true,
  color = '#000000',
  isLoading,
  onRefreshClicked,
}: Props) {
  if (isLoading) {
    return (
      <IconButton disabled style={minStyle}>
        <CircularProgress size={16} />
      </IconButton>
    );
  }

  if (showTooltip) {
    return (
      // @ts-ignore

      <Tooltip
        title="Refresh"
        arrow
        placement="top"
        interactive="true"
        tooltipTheme="dark"
        PopperPros={DefaultTooltipPopperProps}
      >
        <IconButton onClick={onRefreshClicked} style={btnStyle}>
          <RefreshIcon fontSize="large" color={color} />
        </IconButton>
      </Tooltip>
    );
  } else {
    return (
      // @ts-ignore
      <IconButton onClick={onRefreshClicked} style={btnStyle} data-testid="refresh-button">
        <RefreshIcon fontSize="large" color={color} />
      </IconButton>
    );
  }
}
